import { render, staticRenderFns } from "./StockThreadHeader.vue?vue&type=template&id=04374616&scoped=true&"
import script from "./StockThreadHeader.vue?vue&type=script&lang=js&"
export * from "./StockThreadHeader.vue?vue&type=script&lang=js&"
import style0 from "./StockThreadHeader.vue?vue&type=style&index=0&id=04374616&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04374616",
  null
  
)

export default component.exports